import { atom } from "recoil";
import { Region } from "../model";

export const regionsState = atom<Region[] | undefined>({
  key: 'regionsState',
  default: undefined,
});